import React from 'react';
import PropTypes from 'prop-types';
import Button from '../base/Button/GlyphedButton';
import './File.scss';

const FilePreview = (props) => {
    return(
        <div className="col-xs-12">
            <div className="col-xs-12 image-preview">
                <object
                    data={props.file.base64} />
            </div>
            <Button
                floated="right"
                glyph="glyphicon-remove"
                id="cancelBtn"
                label="Zamknij"
                onClick={props.onCancelButtonClick}/>
        </div>
    );
};

FilePreview.propTypes = {
    file: PropTypes.shape({
        base64: PropTypes.string
    }),
    onCancelButtonClick: PropTypes.func
};

export default FilePreview;


// WEBPACK FOOTER //
// ./src/components/File/FilePreview.js